<div class="form-label d-flex gap-2">
  <span [class.required]="isRequired()" [id]="labelId">{{ label() | translate }}</span>
  <ng-content select="[si-help-button]" />
</div>
<div>
  <div [class]="inline() ? '' : 'd-flex flex-column gap-2 mb-2'">
    <ng-content />
  </div>
  @if (hasOnlyRadios()) {
    <div class="invalid-feedback" [class.d-block]="showErrors()">
      @for (error of errors(); track error) {
        <div>
          {{ error.message | translate: error.params }}
        </div>
      }
    </div>
  }
</div>
